/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

/**
 * Listofstation'smaintenance
 */

// required attributes
const StationMaintenanceResourceR = t.interface({
  broker_code: t.string,

  end_date_time: UTCISODateFromString,

  maintenance_id: t.Integer,

  stand_in: t.boolean,

  start_date_time: UTCISODateFromString,

  station_code: t.string
});

// optional attributes
const StationMaintenanceResourceO = t.partial({});

export const StationMaintenanceResource = t.intersection(
  [StationMaintenanceResourceR, StationMaintenanceResourceO],
  "StationMaintenanceResource"
);

export type StationMaintenanceResource = t.TypeOf<
  typeof StationMaintenanceResource
>;
